export default {
    getDepartmentOrders: state => state.orders,
    getTotalOrders: state => state.totalOrders,
    getOrdersListStatuses: state => state.statuses,
    getCountFilters: state => Object
            .entries(state.paramsSearch)
            .filter(([key, value]) => key !== 'statuses' && value).length,
    getPeriodFromFilters: state =>
        !state.paramsSearch['order-date']
            ? ''
            : state.paramsSearch['order-date'].replace('to', '-'),
    getStatusesForFilter: state => {
        const ret = state.statuses.map(e => ({
            value: e.id,
            text: e.name,
            color: e.color,
        }))
        ret.unshift({value: null, text: '-', color: ''})
        return ret
    },
    getErrorOrdersData: state => {
        return state.errorOrdersData ? state.errorOrdersData[0] : state.errorOrdersData
    }
}
